import './index';
import { createTargetElement } from '../shared/utils/helpers';

document.addEventListener('DOMContentLoaded', () => {
  createTargetElement({ elementType: 'tenable-docs-feedback', targetDivSelectors: ['mc-main-content'] });
});
